import React from "react";

import { Navigate } from "react-router-dom";

import { useLiveAnalyticsAccess } from "src/flow/analytics/useLiveAnalyticsAccess";
import { FlowPageParams, getFlowVersionsUrl } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type Props = {
  children: React.ReactNode;
};

// A direct URL to the analytics page bypasses the (hidden) nav item, so send
// visitors of workspaces without access back to the flow's main page. Wait for
// the workspace to load before deciding, otherwise access via the config flag
// would redirect before it's known.
export const LiveAnalyticsRouteGuard: React.FC<Props> = ({ children }) => {
  const { canAccess, isLoading } = useLiveAnalyticsAccess();
  const { orgId, wsId, flow_id: flowId } = useParamsDecode<FlowPageParams>();

  if (canAccess) {
    return <>{children}</>;
  }

  if (isLoading) {
    return null;
  }

  return <Navigate replace to={getFlowVersionsUrl(orgId, wsId, flowId)} />;
};
